import {ExpressionModel} from '../../common/expression.model';
import {Type} from 'class-transformer';
import {BaseIdModel, BaseIdQuery} from 'common-shared';
import {PropertyLineModel} from "./property-line.model";

export class PropertyMappingModel extends BaseIdModel {
  ItemId?: string;
  ItemGroupId?: string;
  @Type(() => ExpressionModel)
  Expression: ExpressionModel = new ExpressionModel();
  @Type(() => ExpressionModel)
  Constraints: ExpressionModel = new ExpressionModel();
  PropertyId: string;
  OrderOriginClv: string;
  MandatoryClv: string;
  ChoiceClassificatorId?: string;
  Sequence?: number;
  Alias?: string;
  LanguageId?: string;
  SourceCode: string;
  SourceType: string;
  SourceId: string;
  ParsedConstraints: any[];
  $default?: PropertyLineModel;
  $inheritedFrom: PropertyMappingModel;
  $Sequence?: number;
  $Code?: string;
  $Language: string;
  $isNew = false;

  constructor(init?: Partial<PropertyMappingModel>) {
    super();
    Object.assign(this, init);
  }
}

export class PropertyMappingQuery extends BaseIdQuery {
  PropertyId: string;
  MandatoryClv: string;
  Sequence?: number;
  Alias?: string;
  LanguageId?: string;
}
